var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page__content"},[(_vm.games && _vm.games.length)?_c('GamesList',{attrs:{"games":_vm.games}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }